import gql from 'graphql-tag';

export default
gql `mutation deleteActivity($input: DeleteActivityInput!){
		deleteActivity(input: $input){
            id
		}
	}
`;


// WEBPACK FOOTER //
// ./src/components/mutations/DeleteActivityMutation.js